import { useTranslation } from "react-i18next";
import { BreadcrumbComponentType } from "use-react-router-breadcrumbs";
import { useAppSelector } from "../hooks/redux";
import { Translations } from "../localization/translations";
import Classifier from "../pages/Classifier";
import ClassifierRecord from "../pages/ClassifierRecord";
import Classifiers from "../pages/Classifiers";
import GlobalSearch from "../pages/GlobalSearch";
import Home from "../pages/Home";
import PageNotFound from "../pages/PageNotFound";

import EasyToReadPage from "../pages/EasyToRead";
import LodResource from "../pages/LodResource";
import LodResources from "../pages/LodResources";
import StaticPage from "../pages/StaticPage";

const GetActiveClassifierCodeBreadcrumb: React.FC = () => {
    const breadcrumbsState = useAppSelector((state) => state.breadcrumbs);
    return <>{breadcrumbsState.classifierCode}</>;
};

const GetActiveClassifierRecordCodeBreadcrumb: React.FC = () => {
    const breadcrumbsState = useAppSelector((state) => state.breadcrumbs);
    return <>{breadcrumbsState.classifierRecordCode}</>;
};

const GetActiveLodResourceCodeBreadcrumb: React.FC = () => {
    const breadcrumbsState = useAppSelector((state) => state.breadcrumbs);
    return <>{breadcrumbsState.lodResourceCode}</>;
};

const GetStaticPagesBreadcrumb: React.FC = () => {
    const breadcrumbsState = useAppSelector((state) => state.breadcrumbs);
    return <>{breadcrumbsState.staticPageTitle}</>;
};

export const GetCurrentAbsoluteUrl = (includeSearchPart?: boolean): string => {
    let absoluteUrl = window.location.href;

    const urlObj = new URL(absoluteUrl);

    return `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}${
        includeSearchPart ? urlObj.search : ""
    }`;
};

export interface IKlasisRoute {
    path?: string;
    index?: boolean;
    element?: React.ReactNode;
    children?: IKlasisRoute[];
    breadcrumb?: string | BreadcrumbComponentType<string>;
}

export const GetRoutes = (): IKlasisRoute[] => {
    const { t } = useTranslation();

    return [
        {
            index: true,
            element: <Home />,
            breadcrumb: t<string>(Translations.routes.title.home),
        },
        {
            path: "global-search",
            element: <GlobalSearch />,
            breadcrumb: t<string>(Translations.routes.title.searchResults),
        },
        {
            path: "classifications",
            breadcrumb: t<string>(Translations.routes.title.classifications),
            children: [
                {
                    index: true,
                    element: <Classifiers />,
                },
                {
                    path: ":id",
                    breadcrumb: GetActiveClassifierCodeBreadcrumb,
                    children: [
                        {
                            index: true,
                            element: <Classifier />,
                        },
                        {
                            path: ":code",
                            breadcrumb: GetActiveClassifierRecordCodeBreadcrumb,
                            element: <ClassifierRecord />,
                        },
                    ],
                },
            ],
        },
        {
            path: "static-page/:path",
            element: <StaticPage />,
            breadcrumb: GetStaticPagesBreadcrumb,
        },
        {
            path: "easy-to-read",
            element: <EasyToReadPage />,
            breadcrumb: t<string>(Translations.routes.title.easyToRead),
        },
        {
            path: "lod-resources",
            breadcrumb: t<string>(Translations.routes.title.lodResources),
            children: [
                {
                    index: true,
                    element: <LodResources />,
                },
                {
                    path: ":id",
                    breadcrumb: GetActiveLodResourceCodeBreadcrumb,
                    element: <LodResource />,
                },
            ],
        },
        {
            path: "*",
            breadcrumb: "404",
            element: <PageNotFound />,
        },
    ];
};
